import React from "react";
import { PropTypes } from "prop-types";
import { LoadioArtistPreviewAlbum } from "administration/loadio/components";
import { PodcastGroupLineLoader } from "administration/podcast/components";
import { MrbContentLoader } from "mrb/components/loader";
import { map } from "lodash";
import { observer } from "mobx-react";

function LoadioArtistPreviewAlbumListTemplate({ loadioArtistPreviewViewStore, t, innerList }) {
    const { item, loaderStore } = loadioArtistPreviewViewStore;

    return (
        <div className={innerList ? "" : "c-container--content--main u-padd--top--none"}>
            <div>
                <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <PodcastGroupLineLoader />}>
                    {() => (
                        <div className="u-animation--fadeIn">
                            {map(item.albums, (album, key) => (
                                <LoadioArtistPreviewAlbum
                                    key={key}
                                    loadioArtistPreviewViewStore={loadioArtistPreviewViewStore}
                                    album={album}
                                    t={t}
                                />
                            ))}
                        </div>
                    )}
                </MrbContentLoader>
            </div>
        </div>
    );
}

LoadioArtistPreviewAlbumListTemplate.propTypes = {
    loadioArtistPreviewViewStore: PropTypes.object.isRequired,
    innerList: PropTypes.bool,
    t: PropTypes.func.isRequired,
};

export default observer(LoadioArtistPreviewAlbumListTemplate);
